<script>
export default {
    name: 'NotFound',
}
</script>

<template lang="pug">
    main
        transition(name="fade")
            router-view
</template>
